import React from 'react';
import './Tabs.css';

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="tabs-container" role="tablist">
      {tabs.map((tab) => {
        const displayLabel = tab.charAt(0).toUpperCase() + tab.slice(1);

        return (
          <button
            key={tab}
            role="tab"
            aria-selected={activeTab === tab}
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => onTabChange(tab)}
          >
            {displayLabel}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
